import React from 'react'
import {createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { subscribeUser } from './subscription'
import moment from 'moment-timezone';

// ReactDOM.render(<App />, document.getElementById('root'))

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.
root.render(<App />);

serviceWorker.register()
subscribeUser()